import 'regenerator-runtime/runtime';
import { call, cancel, put, select, takeEvery } from 'redux-saga/effects';
import {
  AngebotsId,
  ANTRAGSNUMMER_EVENTS,
  DoRequestResponse,
  GlobalAction,
  GlobalActions,
  GlobalPut,
} from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { PS20Logger } from '@ps20-frontend/logging';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { TkvActions } from '../tkvActions';
import { IAppState } from '../appState';

export function* watchAntragsnummerRequested() {
  yield takeEvery(
    GlobalActions.ANTRAGSNUMMER_REQUESTED,
    safeSaga(antragsnummerSagaForAntragsNummerRequested, App.TKV),
  );
  yield takeEvery(
    TkvActions.VORSCHLAGDATEN_CHANGED,
    safeSaga(antragsnummerSagaForVorschlagDatenChanged, App.TKV),
  );
  yield takeEvery(
    ANTRAGSNUMMER_EVENTS.ANTRAGSNUMMER_SUCCESSFULL,
    safeSaga(successCallback, App.TKV),
  );
}

export function* antragsnummerSagaForAntragsNummerRequested(action: GlobalAction<AngebotsId>) {
  const store: IAppState = yield select();
  const angebotsIdInStore = store.angebotsId;
  const { appId, angebotsId } = action.payload;

  if (appId === App.TKV && angebotsId === angebotsIdInStore) {
    yield* doRequestAntragsnummer(angebotsId);
  }
}

export function* antragsnummerSagaForVorschlagDatenChanged() {
  const store: IAppState = yield select();
  const angebotsIdInStore = store.angebotsId;

  yield* doRequestAntragsnummer(angebotsIdInStore);
}

export function* successCallback(successAction: DoRequestResponse<string>) {
  try {
    const { appId, angebotsId } = successAction.doRequestAction.payload;
    const store: IAppState = yield select();
    const angebotsIdInStore = store.angebotsId;
    if (appId === App.TKV && angebotsId === angebotsIdInStore) {
      const globalPut = GlobalPut.getInstance();
      const antragsnummerAsString = successAction.payload.toString();
      yield put(new TkvActions().antragsnummerGenerated(antragsnummerAsString));
      yield call([globalPut, globalPut.put], new GlobalActions().antragsnummerGenerated());
    }
  } catch (exception) {
    PS20Logger.error(
      App.TKV,
      exception as Error,
      'antragsnummerSaga successCallback Antragsnummer konnte nicht verarbeitet werden',
    );
    yield cancel();
  }
}

function* doRequestAntragsnummer(angebotsId: string) {
  const globalPut = GlobalPut.getInstance();

  yield call(
    globalPut.put.bind(globalPut),
    new GlobalActions().doRequestAntragsnummer(
      App.TKV,
      ANTRAGSNUMMER_EVENTS.ANTRAGSNUMMER_SUCCESSFULL,
      ANTRAGSNUMMER_EVENTS.ANTRAGSNUMMER_FAILED,
      angebotsId,
    ),
  );
}
